 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import loadable from "@loadable/component"
import GitHubIcon from "@mui/icons-material/GitHub"
import MenuIcon from "@mui/icons-material/Menu"
import { GlobalStyles } from "@mui/material"
import AppBar from "@mui/material/AppBar"
import CssBaseline from "@mui/material/CssBaseline"
import Drawer from "@mui/material/Drawer"
import IconButton from "@mui/material/IconButton"
import MuiLink from "@mui/material/Link"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemButton from "@mui/material/ListItemButton"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider,
} from "@mui/material/styles"
import Toolbar from "@mui/material/Toolbar"
import useMediaQuery from "@mui/material/useMediaQuery"
import * as React from "react"
import { StrictMode, useCallback, useEffect, useState } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter, Link, Navigate, Route, Routes } from "react-router-dom"

import { ErrorBoundary } from "./ErrorBoundary"
import { isDev } from "./utils/isDev"

const pages = [
  { title: "Hex Sandpiles", module: "hexSandpiles" },
  { title: "Quickhull Animation", module: "quickhull" },
  { title: "Noises", module: "noises" },
  { title: "Raymarching", module: "raymarch" },
  { title: "Delta3D", module: "delta3d", hide: true },
  { title: "Paper Prism Box", module: "paperBox1" },
  { title: "Circle Paper Box", module: "paperBox2" },
  { title: "Paper Box", module: "paperBox3", hide: true },
  { title: "Paper Envelope", module: "paperEnvelope" },
  { title: "Paper Arc Box", module: "paperArcBox" },
  { title: "Paper Polygon Box", module: "paperPolygonBox" },
  { title: "Spirograph", module: "spirograph", hide: true },
  { title: "Tiles", module: "tiles", hide: true },
  { title: "SDFs", module: "sdfs", hide: true },
  { title: "Squigle", module: "squigle", hide: true },
  { title: "SDFs 2D", module: "sdfs2d" },
  { title: "SDFs 3D", module: "sdfs3d" },
]

const AsyncPage = loadable(
  (props) =>
    import(/* webpackChunkName: "[request]" */ `./${props.page}/index`),
  { cacheKey: (props) => props.page },
)

const appGlobalStyles = (
  React.createElement(GlobalStyles, {
    styles: (theme) => ({
      "html, body, #root": {
        margin: "0",
        height: "100%",
        width: "100%",
      },
      "#root": {
        backgroundColor: theme.palette.background.default,
      },
    }),}
  )
)

const GIT_HASH = process.env.GIT_HASH
const BUILD_TIME = new Date(process.env.BUILD_TIME)

const ThemedApp = () => {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)")

  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          // mode: prefersDarkMode ? "dark" : "light",
          // mode: "dark",
          primary: {
            main: "#fe5f55",
          },
          secondary: {
            main: "#f0b67f",
          },
          // primary: { main: "#F26430" },
          // secondary: { main: "#685369" },
          // primary: { main: "#840032" },
          // secondary: { main: "#002642" },
          // primary: { main: "#FFCC00" },
          // secondary: { main: "#ffffff" },
          // background: { default: "#DA281C" },
        },
        // typography: {
        //   fontFamily: "Fira Sans",
        // },
      }),
    [prefersDarkMode],
  )

  return (
    React.createElement(StyledEngineProvider, { injectFirst: true,}
      , React.createElement(ThemeProvider, { theme: theme,}
        , React.createElement(StrictMode, null
          , React.createElement(CssBaseline, null )
          , appGlobalStyles
          , React.createElement(App, null )
        )
      )
    )
  )
}
const App = () => {
  const [navOpen, setNavOpen] = useState(false)

  const onDrawerClose = useCallback(() => setNavOpen(false), [])
  const onHamburgerClick = useCallback(() => setNavOpen(true), [])
  const currentPage = pages.find(
    (p) => p.module === document.location.pathname.split("/")[2],
  )
  useEffect(() => {
    document.title = (_nullishCoalesce(_optionalChain([currentPage, 'optionalAccess', _ => _.title]), () => ( "Loading..."))) + " - Adrian Leonhard"
  }, [currentPage])

  return (
    React.createElement(BrowserRouter, { basename: "/workshop/",}
      , React.createElement(Drawer, { open: navOpen, onClose: onDrawerClose,}
        , React.createElement(List, { onClick: () => setNavOpen(false),}
          , pages
            .filter(({ hide }) => isDev() || !hide)
            .map(({ title, module, hide }) => (
              React.createElement(ListItemButton, { component: Link, key: module, to: `/${module}`,}
                , React.createElement(ListItemText, null, title)
                , hide && React.createElement('small', null, "dev")
              )
            ))
          , React.createElement(ListItemButton, {
            component: "a",
            href: "https://github.com/NaridaL/workshop",}

            , React.createElement(ListItemIcon, null
              , React.createElement(GitHubIcon, null )
            )
            , React.createElement(ListItemText, null, "Github")
          )
          , React.createElement(ListItem, {
            sx: {
              fontSize: "smaller",
              flexDirection: "column",
              alignItems: "flex-start",
            },}

            , React.createElement('div', null, "SHA1"
              , " "
              , React.createElement(MuiLink, {
                href: "https://github.com/NaridaL/workshop/tree/" + GIT_HASH,}

                , GIT_HASH.substring(0, 6)
              )
            )
            , React.createElement('div', null, "BUILT " , BUILD_TIME.toISOString().substring(0, 16))
          )
        )
      )
      , React.createElement(AppBar, { position: "static",}
        , React.createElement(Toolbar, { variant: "dense",}
          , React.createElement(IconButton, {
            edge: "start",
            color: "inherit",
            'aria-label': "menu",
            onClick: onHamburgerClick,
            size: "large",}

            , React.createElement(MenuIcon, null )
          )
          , React.createElement('h2', null, " " , _nullishCoalesce(_optionalChain([currentPage, 'optionalAccess', _2 => _2.title]), () => ( "Loading...")))
        )
      )

      , React.createElement(Routes, null
        , pages.map(({ module }) => (
          React.createElement(Route, {
            key: module,
            path: `/${module}`,
            element: 
              React.createElement(ErrorBoundary, null
                , React.createElement(AsyncPage, { page: module,} )
              )
            ,}
          )
        ))
        , React.createElement(Route, {
          path: "/dist/:where",
          element: React.createElement(Navigate, { replace: true, to: "/:where",} ),}
        )
        , React.createElement(Route, { path: "/", element: React.createElement(Navigate, { replace: true, to: "/hexSandpiles",} ),} )
        , React.createElement(Route, { path: "/dist", element: React.createElement(Navigate, { replace: true, to: "/hexSandpiles",} ),} )
        , React.createElement(Route, { path: "/",}, "404")
      )
    )
  )
}

const root = createRoot(document.getElementById("root"))
root.render(React.createElement(ThemedApp, null ))
